import {Action} from "redux-actions";
import {combineReducers} from "redux";
import {GeoState, SearchFiltersState} from "../_definitions/styleteq";
import {
    addSearchSecondaryFilterAction,
    clearSearchFiltersAction,
    clearSearchItemsAction,
    clearSearchSecondaryFilterAction,
    incrementSearchTrendingCategoriesCount,
    receiveSearchItemsAction,
    removeSearchSecondaryFilterAction,
    requestSearchItemsAction,
    resetSearchTrendingCategoriesCount,
    setSearchFilterTypeAction,
    setSearchGeoLocationAction,
    setSearchLocationAction, setSearchNoResultsFound,
    setSearchQueryAction, setSearchSecondaryFilterAction,
    setSearchView,
    toggleSearchFiltersAction,
    requestSearchGeoLocationAction,
} from "./actions";
import * as _ from "lodash";
import SearchResult from "../_data/models/SearchResult";
import {OrderedMap} from "immutable";
import Meta from "../_data/models/Meta";
import {addData, ResourceType} from "../_helpers/data";
import {plainToClass} from "class-transformer";

//interfaces
interface SearchAction {
    type: string;
    secondaryFilters: string[];
    secondaryFilter: string;
    query: string;
    location: string;
    data: any;
    meta: Meta;
    coords: Coordinates;
    view: SearchView;
}

export enum SearchView {
    SEARCH,
    TRENDING
}

//initial states
const initialFilters = {
    enabled: false,
    typeFilter: null,
    secondaryFilters: []
};
const initialResults = OrderedMap<number, SearchResult>();

const initialGeo = {
    latitude: null,
    longitude: null,
    address: ''
};


//reducers
const searchReducer = combineReducers({
    filters,
    query,
    results,
    meta,
    loading,
    loadingMessage,
    geo,
    trendingCategoriesCount,
    view,
    noSearchResultsFound
});
export default searchReducer;

function filters(state: SearchFiltersState = initialFilters, action: Action<SearchAction>) {
    switch (action.type) {
        case toggleSearchFiltersAction.toString():
            return {...state, enabled: !state.enabled};
        case setSearchFilterTypeAction.toString():
            return {...state, typeFilter: action.payload.type};
        case setSearchSecondaryFilterAction.toString():
            return {...state, secondaryFilters: action.payload.secondaryFilters};
        case addSearchSecondaryFilterAction.toString():
            return {...state, secondaryFilters: [...state.secondaryFilters, action.payload.secondaryFilter]};
        case removeSearchSecondaryFilterAction.toString():
            return {...state, secondaryFilters: _.without(state.secondaryFilters, action.payload.secondaryFilter)};
        case clearSearchSecondaryFilterAction.toString():
            return {...state, secondaryFilters: []};
        case clearSearchFiltersAction.toString():
            return initialFilters;
    }
    return state;
}

function query(state: string = '', action: Action<SearchAction>) {
    switch (action.type) {
        case setSearchQueryAction.toString():
            return action.payload.query;
        case clearSearchFiltersAction.toString():
            return '';
    }
    return state;
}

function results(state: OrderedMap<number, SearchResult> = initialResults, action: Action<SearchAction>) {
    switch (action.type) {
        case receiveSearchItemsAction.toString():
            return addData(ResourceType.search, action.payload.data, state);
        case clearSearchItemsAction.toString():
            return state.clear();
    }
    return state;
}

function meta(state: Meta = null, action: Action<SearchAction>) {
    switch (action.type) {
        case receiveSearchItemsAction.toString():
            return plainToClass(Meta, action.payload.meta);
        case clearSearchItemsAction.toString():
            return null;
    }
    return state;
}

function loading(state: boolean = false, action: Action<SearchAction>) {
    switch (action.type) {
        case requestSearchItemsAction.toString():
        case requestSearchGeoLocationAction.toString():
            return true;
        case receiveSearchItemsAction.toString():
            return false;
    }
    return state;
}

function loadingMessage(state: string = null, action: Action<SearchAction>) {
    switch (action.type) {
        case requestSearchItemsAction.toString():
            return "Fetching data from server.";
        case requestSearchGeoLocationAction.toString():
            return "Getting current location.";
        case receiveSearchItemsAction.toString():
            return null;
    }
    return state;
}

function geo(state: GeoState = initialGeo, action: Action<SearchAction>) {
    switch (action.type) {
        case setSearchLocationAction.toString():
            return {...state, address: action.payload.location};
        case setSearchGeoLocationAction.toString():
            const {latitude, longitude} = action.payload.coords;
            return {...state, latitude: latitude, longitude: longitude};
        case clearSearchFiltersAction.toString():
            return initialGeo;
    }
    return state;
}

function trendingCategoriesCount(state: number = 0, action: Action<SearchAction>) {
    switch (action.type) {
        case incrementSearchTrendingCategoriesCount.toString():
            return state + 1;
        case resetSearchTrendingCategoriesCount.toString():
            return 0;
    }
    return state;
}

function view(state: number = SearchView.TRENDING, action: Action<SearchAction>) {
    switch (action.type) {
        case setSearchView.toString():
            return action.payload.view;
    }
    return state;
}

function noSearchResultsFound(state: boolean = false, action: Action<SearchAction>) {
    switch (action.type) {
        case setSearchNoResultsFound.toString():
            return true;
        case setSearchView.toString():
            return false;
    }
    return state;
}


// WEBPACK FOOTER //
// ./app/client/search/reducers.ts